<template>
	<div
		class="g-block-title-double-line g-block-title-padding"
		:class="{
			'g-block-title-double-line--edit': editable,
			'is-active': editable && active,
			'g-block-title-double-line--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-double-line__content">
			<span class="g-block-title-double-line__line" :style="{ background: themeColor }"></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-double-line__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-double-line__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-double-line__line" :style="{ background: themeColor }"></span>
			<span class="g-block-title-double-line__arrow" :style="{ borderTopColor: themeColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleDoubleLine',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-double-line {
		.title-block-edit-shell();
	}

	.g-block-title-double-line__content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}

	.g-block-title-double-line__line {
		width: 100%;
		height: 1px;
	}

	.g-block-title-double-line__text {
		font-size: 22px;
		font-weight: 700;
		line-height: 1.3;
		text-align: center;
		padding: 0 12px;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; text-align: center; }
	}

	.g-block-title-double-line__arrow {
		width: 0;
		height: 0;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-top: 8px solid;
	}

	.g-block-title-double-line--h5 {
		.g-block-title-double-line__content { gap: 0.2rem; }
		.g-block-title-double-line__text { font-size: 0.44rem; padding: 0 0.24rem; }
		.g-block-title-double-line__line { height: 0.02rem; }
		.g-block-title-double-line__arrow {
			border-left-width: 0.12rem;
			border-right-width: 0.12rem;
			border-top-width: 0.16rem;
		}
	}
</style>
